import { useState } from "react";
import axios from "axios";
import { ArrowUpRight } from "lucide-react";
import { toast } from "sonner";
import { Reveal, PageHero, useSeo } from "../components/Shared";
import { EMAIL, INTERN_FIELDS } from "../data/content";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Internship() {
  useSeo(
    "Internship | Dishan International Group",
    "Apply for an internship at Dishan International Group, real projects across consulting, branding, education, wellness and media."
  );
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await axios.post(`${API}/internships`, Object.fromEntries(new FormData(e.currentTarget)));
      setSent(true);
      toast.success("Internship application received. We'll be in touch shortly.");
      e.currentTarget.reset();
    } catch {
      toast.error(`We couldn't send that just now. Please email ${EMAIL}.`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <PageHero
        eyebrow="Internship"
        titleKey="internship.hero.title" title="Learn by doing real work."
        subtitleKey="internship.hero.subtitle" subtitle="Our internships place students and early-career professionals inside live projects, with mentorship, structure and a certificate that reflects genuine contribution."
      />
      <main>
        <section className="section">
          <div className="container form-layout">
            <Reveal>
              <span className="eyebrow">What to expect</span>
              <h2>Experience, not errands.</h2>
              <p>Interns at Dishan work on real briefs across consulting, branding, education, psychology & wellness, content and operations, guided by practitioners, reviewed with care.</p>
              <ul className="check-list">
                <li>Live projects with real deliverables and feedback</li>
                <li>Mentorship from the founding and consulting team</li>
                <li>Certificate, recommendation and career exposure on completion</li>
              </ul>
            </Reveal>
            <Reveal delay={0.1}>
              <form className="form-card" onSubmit={submit} data-testid="internship-form">
                <h3>Internship application</h3>
                <div className="form-row">
                  <label>Full name<input name="name" required placeholder="Your name" data-testid="internship-name-input" /></label>
                  <label>Email<input name="email" type="email" required placeholder="you@email.com" data-testid="internship-email-input" /></label>
                </div>
                <div className="form-row">
                  <label>Phone<input name="phone" placeholder="+91" data-testid="internship-phone-input" /></label>
                  <label>Institution / university<input name="institution" required placeholder="Where are you studying?" data-testid="internship-institution-input" /></label>
                </div>
                <div className="form-row">
                  <label>Field of interest
                    <select name="field_of_interest" required data-testid="internship-field-select">
                      <option value="">Select a field</option>
                      {INTERN_FIELDS.map((f) => <option key={f}>{f}</option>)}
                    </select>
                  </label>
                  <label>Preferred duration
                    <select name="duration" data-testid="internship-duration-select">
                      <option value="">Select duration</option>
                      <option>1 month</option><option>2 months</option><option>3 months</option><option>6 months</option>
                    </select>
                  </label>
                </div>
                <label>Availability
                  <select name="availability" data-testid="internship-availability-select">
                    <option value="">Select mode</option>
                    <option>On-site (Kolkata)</option><option>Remote</option><option>Hybrid</option>
                  </select>
                </label>
                <label>Why do you want this internship?<textarea name="motivation" required rows={4} placeholder="Tell us what you hope to learn and contribute..." data-testid="internship-motivation-input" /></label>
                <button className="btn btn-primary form-submit" type="submit" disabled={loading} data-testid="internship-submit-button">
                  {loading ? "Sending…" : "Apply for Internship"} <ArrowUpRight size={16} />
                </button>
                {sent && <p className="success-message" data-testid="internship-success-message">Thank you, your internship application has been received.</p>}
              </form>
            </Reveal>
          </div>
        </section>
      </main>
    </>
  );
}
